// src/components/ContactSection.jsx
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ContactBackground from "../../assets/restaurant/restaurante-background2.jpg";

const Contact = ({ primaryColor = "#43bd98" }) => {
	const { t } = useTranslation();

	return (
		<section
			id="contacto"
			style={{
				position: "relative",
				padding: "6rem 1rem",
				textAlign: "center",
				color: "#fff",
				backgroundImage: `url(${ContactBackground})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			{/* Overlay oscuro */}
			<div
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					background: "rgba(0,0,0,0.55)",
					zIndex: 0,
				}}
			/>

			{/* Contenido */}
			<div
				style={{
					position: "relative",
					zIndex: 1,
					maxWidth: "700px",
					margin: "0 auto",
				}}
			>
				<motion.p
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
					viewport={{ once: true }}
					style={{
						color: primaryColor,
						fontSize: "0.9rem",
						fontWeight: 600,
						letterSpacing: "1px",
						textTransform: "uppercase",
						marginBottom: 0,
					}}
				>
					{t("contact.subtitle")}
				</motion.p>

				<motion.h2
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2 }}
					viewport={{ once: true }}
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						color: "#fff",
						fontWeight: 800,
						marginBottom: "1rem",
						marginTop: 20,
					}}
				>
					{t("contact.title")}
				</motion.h2>

				<motion.p
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.4 }}
					viewport={{ once: true }}
					style={{
						maxWidth: "500px",
						margin: "0 auto 2.5rem",
						color: "#f1f1f1",
					}}
				>
					{t("contact.text")}
				</motion.p>

				<motion.div
					initial="hidden"
					whileInView="show"
					viewport={{ once: true }}
					transition={{ staggerChildren: 0.2 }}
					style={{
						display: "flex",
						justifyContent: "center",
						gap: "1rem",
						flexWrap: "wrap",
					}}
				>
					<motion.a
						href="https://wa.me/34608916357"
						target="_blank"
						rel="noopener noreferrer"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						style={{
							padding: "0.9rem 1.8rem",
							backgroundColor: "#25D366",
							color: "#fff",
							borderRadius: "8px",
							fontWeight: 600,
							fontSize: "0.95rem",
							textDecoration: "none",
						}}
					>
						{t("contact.whatsapp")}
					</motion.a>

					<motion.a
						href="mailto:info@applaby.com"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						style={{
							padding: "0.9rem 1.8rem",
							backgroundColor: primaryColor,
							color: "#fff",
							borderRadius: "8px",
							fontWeight: 600,
							fontSize: "0.95rem",
							textDecoration: "none",
						}}
					>
						{t("contact.email")}
					</motion.a>
				</motion.div>
			</div>
		</section>
	);
};

export default Contact;
